export enum InvoiceType {
  Custom = 'custom',
  Credit = 'credit',
}
